export default __webpack_public_path__ + "assets/documents.51bb426d.svg";